import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  CommandIcon,
  IDefaultDevicesSettingsDTO,
} from '@/../client-generator/generated-clients/device-settings';
import {
  LettersCommandIcons,
  NumbersCommandIcons,
  SymbolsLightCommandIcons,
  SymbolsLockCommandIcons,
  SymbolsSceneCommandIcons,
  getCommandIconFromType,
} from './CommandIconHelper';

@Options({
  name: 'CommandIconComponent',
  props: {
    defaultSettings: {
      type: Object as PropType<IDefaultDevicesSettingsDTO>,
      required: true,
    },
    deviceName: {
      type: String,
      default: '',
    },
    isScene: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    activeTabIndex(newValue) {
      this.showFilteredCommandIcons(newValue);
    },
  },
  emits: ['update:defaultSettings'],
})
export default class CommandIconComponent extends Vue {
  defaultSettings!: IDefaultDevicesSettingsDTO;
  activeTabIndex = 0;
  deviceName!: string;
  isScene!: boolean;
  readonly!: boolean;

  CommandIcon = CommandIcon;
  getCommandIconFromType = getCommandIconFromType;

  commandIcons: CommandIcon[] = [];

  created() {
    this.showFilteredCommandIcons(this.activeTabIndex);
  }

  changeIcon(selectedIcon: CommandIcon) {
    if (this.readonly) return;
    this.defaultSettings.selectedCommandIcon = selectedIcon;
  }

  showFilteredCommandIcons(tabIndex: number) {
    let symbolsCommandIcons: CommandIcon[] = [];
    let lettersCommandIcons: CommandIcon[] = [];
    let numbersCommandIcons: CommandIcon[] = [];

    if (this.isScene) {
      symbolsCommandIcons = SymbolsSceneCommandIcons;
      lettersCommandIcons = LettersCommandIcons;
      numbersCommandIcons = NumbersCommandIcons;
    } else {
      if (this.defaultSettings.lockCommandSettings != null) {
        symbolsCommandIcons = SymbolsLockCommandIcons;
        lettersCommandIcons = LettersCommandIcons;
        numbersCommandIcons = NumbersCommandIcons;
      } else {
        symbolsCommandIcons = SymbolsLightCommandIcons;
        lettersCommandIcons = LettersCommandIcons;
        numbersCommandIcons = NumbersCommandIcons;
      }
    }

    switch (tabIndex) {
      case 0:
        this.commandIcons = symbolsCommandIcons.concat(
          lettersCommandIcons,
          numbersCommandIcons
        );
        break;
      case 1:
        this.commandIcons = symbolsCommandIcons;
        break;
      case 2:
        this.commandIcons = lettersCommandIcons;
        break;
      case 3:
        this.commandIcons = numbersCommandIcons;
        break;
    }
  }
}
